var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 3.97674C0 1.78045 1.78045 0 3.97674 0C6.17304 0 7.95349 1.78045 7.95349 3.97674C7.95349 6.17304 6.17304 7.95349 3.97674 7.95349C1.78045 7.95349 0 6.17304 0 3.97674Z",
    fill: "#212129"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.0231C0 11.8268 1.78045 10.0464 3.97674 10.0464C6.17304 10.0464 7.95349 11.8268 7.95349 14.0231C7.95349 16.2195 6.17304 17.9999 3.97674 17.9999C1.78045 17.9999 0 16.2195 0 14.0231Z",
    fill: "#546088"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.0465 14.0231C10.0465 11.8268 11.8269 10.0464 14.0233 10.0464C16.2196 10.0464 18 11.8268 18 14.0231C18 16.2195 16.2196 17.9999 14.0233 17.9999C11.8269 17.9999 10.0465 16.2195 10.0465 14.0231Z",
    fill: "#212129"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.814 0.418457C14.2763 0.418457 14.6512 0.793292 14.6512 1.25567V3.34869H16.7442C17.2066 3.34869 17.5814 3.72352 17.5814 4.1859C17.5814 4.64827 17.2066 5.02311 16.7442 5.02311H14.6512V7.11613C14.6512 7.57852 14.2763 7.95334 13.814 7.95334C13.3516 7.95334 12.9767 7.57852 12.9767 7.11613V5.02311H10.8837C10.4213 5.02311 10.0465 4.64827 10.0465 4.1859C10.0465 3.72352 10.4213 3.34869 10.8837 3.34869H12.9767V1.25567C12.9767 0.793292 13.3516 0.418457 13.814 0.418457Z",
    fill: "#546088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.2a0de9bbb79bfe18f0941006951ed1e2.svg";
export { ForwardRef as ReactComponent };